import {colors} from "styles";
import {useAppSelector} from "hooks";
import {ButtonStyled} from "./styled";
import {getSpinnerColors} from "./helper";
import {ButtonLoaderId} from "interfaces";
import {useTheme} from "styled-components";
import {ColorRing} from "react-loader-spinner";
import {Row, Typography, TypographyProps} from "../..";
import {ButtonHTMLAttributes, Fragment, JSX} from "react";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  label: string;
  color?: string;
  leftIcon?: JSX.Element;
  rightIcon?: JSX.Element;
  loaderId?: ButtonLoaderId;
  typographyProps?: Omit<TypographyProps, "children">;
}

export const Button: React.FC<ButtonProps> = (props) => {
  const {
    label,
    style,
    loaderId,
    leftIcon,
    rightIcon,
    typographyProps,
    disabled = false,
    color = colors["black"],
    ...buttonProps
  } = props;
  const {buttonLoaderIds} = useAppSelector("layout");
  const {isDark, primary, disabledButtonTextColor} = useTheme();
  const loaderColor = getSpinnerColors(primary);
  const buttonTextColor = disabled ? disabledButtonTextColor : color;
  const loading = buttonLoaderIds["includes"](loaderId as ButtonLoaderId);

  return (
    <ButtonStyled
      style={style}
      $darkMode={isDark}
      disabled={disabled || loading}
      $disabled={disabled || loading}
      children={
        <Row gap={5} justifyContent="center">
          {loading ? (
            <ColorRing
              width="40"
              height="40"
              visible={loading}
              colors={loaderColor}
            />
          ) : (
            <Fragment>
              {leftIcon && leftIcon}
              <Typography color={buttonTextColor} {...typographyProps}>
                {label}
              </Typography>
              {rightIcon && rightIcon}
            </Fragment>
          )}
        </Row>
      }
      {...buttonProps}
    />
  );
};
